import { Attr, BelongsTo, HasOne, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";
import type { Nullable } from "shared/types";
import type { BroadcastProvider } from "shared/types/mentions";

import type RadioProgramAiring from "./RadioProgramAiring";
import type RadioStation from "./RadioStation";

@Model()
class RadioClip extends ApplicationRecord {
  static jsonapiType = "radio_clips";

  @Attr({ persist: false }) advertisementRate: number;

  @Attr({ persist: false }) advertisementRateCurrency: string;

  @Attr({ persist: false }) audience: number;

  @Attr({ persist: false }) audienceBlockId: number;

  @Attr({ persist: false }) broadcastProvider?: Nullable<BroadcastProvider>;

  @Attr({ persist: false }) cisionSource: string;

  @Attr({ persist: false }) copyrightLabelId: number;

  @Attr({ persist: false }) createdAt: string;

  @Attr({ persist: false }) endTime: number;

  @Attr({ persist: false }) languageCode: string;

  @BelongsTo() programAiring: RadioProgramAiring;

  @Attr({ persist: false }) programId: number;

  @Attr({ persist: false }) radioProgramAiringId: number;

  @BelongsTo() source: RadioStation;

  @Attr({ persist: false }) speechPercentage: number;

  @Attr({ persist: false }) startTime: number;

  @Attr({ persist: false }) stationId: number;

  @HasOne() syndicatedRadioClip: RadioClip;

  @Attr({ persist: false }) syndicationId: number;

  @Attr({ persist: false }) text: string;

  @Attr({ persist: false }) transcribedAt: string;

  @Attr({ persist: false }) tveyesEditorUrl: Nullable<string>;

  @Attr({ persist: false }) tveyesPlayerUrl: Nullable<string>;

  @Attr({ persist: false }) tveyesSlimPlayerUrl: Nullable<string>;

  @Attr({ persist: false }) type: string;

  @Attr({ persist: false }) ucpId: string;

  @Attr({ persist: false }) ucpPublicationProvidedId: string;

  @Attr({ persist: false }) url: string;

  @Attr({ persist: false }) utcdeltaMinutes: number;
}

export default RadioClip;
